<template>
  <transition name="el-zoom-in-top">
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
       
      </section>
      <!-- Main content -->
      <section class="content">
        <el-dialog
          title="Forgot Email"
          customClass="customWidth"
          :visible.sync="dialogVisible"
          size="tiny"
          visible="false"
          :before-close="handleClose"
          v-show="showDialog"
        >
          <div class="account-box">
            <form role="form">
              <p class="instructionalText"  >
               Please contact customer support at: <strong>1(888)-233-4445<br><br> We will assist you in retreiving the email address associated with your account.</strong>
              </p>
                            

            </form>
            <hr />
            <div class="row-block">
              <div class="row"></div>
            </div>
          </div>
        </el-dialog>
      </section>
      <!-- /.content -->
    </div>
  </transition>
</template>
<script>
var Auth = require("../services/Authentication/auth");
var to = require("await-to-js").default;
var db = require('../services/database/database')
const { v4: uuidv4 } = require('uuid');
const cliStorage = require('../services/libraries/clientStoragelib')
const cliStorNames = cliStorage.clientStorageNames
export default {
  data: function () {
    return {
      dialogVisible: false,
      showDialog: true,
      phoneChecked: "",
      emailChecked: "",
    };
  },
  methods: {
    handleClose: function (done) {
      this.showDialog = false;
      this.$router.push("/login");
      // this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
      //   confirmButtonText: 'OK',
      //   cancelButtonText: 'Cancel',
      //   type: 'warning'
      // })
    },
    deleteCookies: function(){
       this.$cookie.delete(cliStorNames.USER_TOKEN.name)
           this.$cookie.delete(cliStorNames.REFRESH_TOKEN.name)
    },
    Submit: async function () {
      //CLEAN THIS UP
    // const fs = require('../../firestore')
    
    // Create a new client
      const UID = this.$route.params.user.userID;
      const user = this.$route.params.user
      var emailChecked = this.emailChecked;
      var phoneChecked = this.phoneChecked;
          console.log("user UID", UID)

      if (!emailChecked && !phoneChecked) {
        console.log("need to select at least one verification method");
        return;
      }
      if (emailChecked) {
        let email = user.email
        let error, result;
        [error, result] = await to(
          Auth.passwordResetEmail({ UID, email}, )
        );
      this.$router.push("/login");

        if (error) {
          console.log("error", error.response);
          const errorMsg = error.response.data.error.message;
          this.$confirm("unable to send email." + errorMsg, 
          {
        cancelButtonText: 'Cancel',
        confirmButtonText: 'OK',
        type:'error'});
        } else if (result) {
          console.log("result", result);
        }
          
          console.log("user", user)
         let document = 
       {
  fields: {"first_name":
  {"stringValue": user.firstName},
  "last_name":
  {"stringValue": user.lastName},
  "phone":
  {"stringValue": user.phone},
  "email":
  {"stringValue": user.email},
  "zip":
  {"stringValue": user.zipcode},
  "city":
  {"stringValue": user.city},
  "state":
  {"stringValue": user.state},
  "user_id":
  {"stringValue": uuidv4()}
  }
  }
    //second argument should be the EXPIRY length of firebase's email verification link
     this.handleInterval(4000,9000000,UID,document, user)
     
    
}
      },
  
  },
};
</script>
<style scoped>
.instructionalText {
  font-weight: "bold";
  text-align: auto;
        font-size: 1.6vw;

}
.wrapper {
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 1fr;
}

.options-alignment {
  padding-top: 50px;
  align-content: center;
}

.box1 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 2;
}

.box2 {
  grid-column-start: 3;
  grid-column-end: 4;

  grid-row-start: 1;
  grid-row-end: 2;
  z-index: 1;
}

.paragraph-font{
    font-size: 13pt;
      font-size: 1vw;

}

.data-font{
    font-weight: bold;
}

@media(max-width:450px){
  
.customWidth{
        width:90%;
        
    }
  
}
.customWidth{
        width:90%;
        
    }
@media(min-width:450px){
  
.customWidth{
        width:50%;
        
    }
  
}

</style>


// WEBPACK FOOTER //
// ForgotEmail.vue?43355da7